export enum FeedbackType {
  EXPLICIT = 'explicit',
  IMPLICIT = 'implicit',
}

export interface Feedback {
  id?: string;
  user_id: string;
  work_id?: string;
  feedback_type: FeedbackType;
  feedback_content?: string;
  created_at?: string;
  updated_at?: string;
  metadata?: Record<string, any>;
  location_url?: string;
  location_page?: string;
  location_element?: string;
  star_rating: number;
  is_issue?: boolean;
}

export interface FeedbackFormData {
  feedback_content: string;
  star_rating?: number;
  location_page?: string;
  location_element?: string;
  metadata?: Record<string, any>;
  is_issue?: boolean;
}
